// translations/invoiceConversion.ts
export const translations = {
    en: {
      'converter.buttons.usesCredit': '(Uses 1 credit)',
      'converter.buttons.startNew': 'Start New',
      'converter.pdfToXml.title': 'PDF to XRechnung Converter',
      'converter.pdfToXml.subtitle': 'Convert your PDF invoices to structured XML/XRechnung format in seconds',
      'converter.converter': 'Converter',
      'converter.xmlToPdf.subtitle': 'Convert your XML/XRechnung files to PDF format in seconds',
      'converter.dropzone.title': 'Drag & drop your invoice here',
      'converter.dropzone.dragActive': 'Drop the file here',
      'converter.dropzone.browse': 'or click to browse',
      'converter.dropzone.supportedPdf': 'Supported format: PDF (max 10MB)',
      'converter.dropzone.supportedXml': 'Supported format: XML (max 10MB)',
      'converter.dropzone.noFile': 'No file chosen',
      'converter.dropzone.clickToReplace': 'Click or drag to replace',
      'converter.steps.uploadPdf': 'Upload PDF',
      'converter.steps.uploadXml': 'Upload XML',
      'converter.steps.viewData': 'Review Data',
      'converter.steps.downloadXml': 'Download XRechnung',
      'converter.steps.downloadPdf': 'Download PDF',
      'converter.buttons.back': 'Back',
      'converter.buttons.next': 'Next',
      'converter.buttons.convertAnother': 'Convert Another File',
      'converter.errors.selectXml': 'Please select an XML file.',
      'converter.errors.pdfGeneration': 'PDF generation failed. Please try again.',
      'converter.buttons.downloadPdf': 'Download PDF',
      'converter.buttons.downloadXml': 'Download XRechnung',
      'converter.currentCredits': 'Current Credits: {count}',
      'converter.downloadDisclaimer': 'By downloading, you confirm you’ve reviewed all data for accuracy, acknowledge AI may make mistakes, and accept full responsibility.',
      'converter.xmlContent': 'XML Content',
      'converter.parsedData': 'Parsed Data',

      'upload.steps': [
        'Upload & Extract',
        'Confirm & Edit',
        'Download XRechnung'
      ],
      'upload.dropzone.title': 'Drag & drop your invoice here',
      'upload.dropzone.dragActive': 'Drop the PDF here',
      'upload.dropzone.browse': 'or click to browse',
      'upload.dropzone.supportedFormatsPDF': 'Supported format: PDF (max 10MB)',
      'upload.dropzone.supportedFormatsXML': 'Supported format: XML (max 10MB)',
      'upload.dropzone.clickToReplace': 'Click or drag to replace',
      'upload.review.title': 'Review & Edit Invoice Data',
      'upload.review.checkCarefully': 'All fields are editable - please check carefully!',
      'upload.review.noData': 'No data available. Please upload an invoice first.',
      'upload.xml.title': 'Generated XRechnung',
      'upload.buttons.back': 'Back',
      'upload.buttons.next': 'Next',
      'upload.buttons.downloadXml': 'Download XRechnung',
      'upload.buttons.uploadPdf': 'Upload PDF',
      'upload.buttons.checkData': 'Check Data',
      'upload.loading.processing': 'Processing your invoice...',
      'upload.loading.extracting': 'Extracting invoice data...',
      'upload.loading.analyzing': 'Analyzing document structure...',
      'upload.loading.mapping': 'Mapping to XRechnung XML format...',
      'upload.loading.schema': 'Applying XRechnung schema...',
      'upload.loading.validating': 'Validating output...',
      'upload.errors.noFile': 'Please select a PDF file.',
      'upload.errors.uploadFailed': 'Failed to upload and process the file.',
      'upload.errors.xmlFailed': 'Failed to generate XML.',
      'upload.errors.safariNetworkIssue': 'Safari network issue detected. Try keeping this tab active or switch to Chrome/Firefox for better performance.',
      'upload.errors.safariTimeout': 'Safari timeout detected. Please refresh the page and try again, or consider using Chrome/Firefox.',
      'upload.validation.missingFields': 'Some recommended fields are empty. You can still proceed, but filling them might be required for government exchange.',
      'upload.validation.generateXml': 'Generate XML',

      // Processing status messages
      'converter.processing.pending': 'Processing queued...',
      'converter.processing.analyzing': 'Analyzing invoice...',
      'converter.processing.completed': 'Processing completed!',
      'converter.processing.failed': 'Processing failed',
      'converter.processing.unknown': 'Processing...',

      // New invoice fields translations (English)
      invoiceFields: {
        ID: {
          label: 'Invoice Number',
          description: 'Unique identifier for this invoice'
        },
        IssueDate: {
          label: 'Issue Date',
          description: 'Date when the invoice was issued'
        },
        DueDate: {
          label: 'Due Date',
          description: 'Date by which the payment should be made'
        },
        InvoiceTypeCode: {
          label: 'Invoice Type',
          description: 'Type of invoice (e.g., "380" for standard invoice)',
          selectPlaceholder: '--- Select Invoice Type ---'
        },
        DocumentCurrencyCode: {
          label: 'Currency',
          description: 'Main currency used (e.g., "EUR")'
        },
        OrderReference: {
          label: 'Order Reference',
          description: 'Buyer\'s purchase order number'
        },
        ContractReference: {
          label: 'Contract Reference',
          description: 'Contract reference number'
        },
        BuyerReference: {
          label: 'Buyer Reference',
          description: 'Buyer\'s internal reference number'
        },
        Seller: {
          LegalName: {
            label: 'Legal Name',
            description: 'Official registered name of the selling company'
          },
          CompanyID: {
            label: 'VAT Identifier',
            description: 'VAT registration number of the seller'
          },
          CompanyLegalForm: {
            label: 'Company Legal Form',
            description: 'Legal form of the selling company'
          },
          Street: {
            label: 'Street',
            description: 'Street address of the seller'
          },
          City: {
            label: 'City',
            description: 'City of the seller'
          },
          PostalCode: {
            label: 'Postal Code',
            description: 'Postal code of the seller'
          },
          CountryCode: {
            label: 'Country Code',
            description: 'Two-letter country code of the seller'
          },
          EndpointID: {
            label: 'Electronic address',
            description: 'Identifies the Seller\'s electronic address to which the application level response to the invoice may be delivered.'
          },
          Email: {
            label: 'Email',
            description: 'Contact email address of the seller'
          },
          ContactName: {
            label: 'Contact Name',
            description: 'Name of the contact person at the selling company'
          },
          Phone: {
            label: 'Phone',
            description: 'Contact phone number of the seller'
          }
        },
        Buyer: {
          LegalName: {
            label: 'Legal Name',
            description: 'Official registered name of the buying company'
          },
          Street: {
            label: 'Street',
            description: 'Street address of the buyer'
          },
          City: {
            label: 'City',
            description: 'City of the buyer'
          },
          PostalCode: {
            label: 'Postal Code',
            description: 'Postal code of the buyer'
          },
          CountryCode: {
            label: 'Country Code',
            description: 'Two-letter country code of the buyer'
          },
          EndpointID: {
            label: 'Electronic address',
            description: 'Identifies the Buyer\'s electronic address to which the application level response to the invoice may be delivered.'
          }
        },
        Payment: {
          IBAN: {
            label: 'IBAN',
            description: 'International Bank Account Number for payment (e.g., IBAN)'
          },
          BIC: {
            label: 'BIC',
            description: 'Bank Identifier Code'
          },
          Type: {
            label: 'Type',
            description: 'Type of payment'
          },
          Terms: {
            label: 'Terms',
            description: 'Payment terms description (e.g., "Net within 30 days")'
          }
        },
        Tax: {
          Amount: {
            label: 'Tax Amount',
            description: 'Total VAT amount'
          },
          BaseAmount: {
            label: 'Base Amount',
            description: 'Amount on which VAT is calculated'
          },
          TaxSubamount: {
            label: 'Tax Subamount',
            description: 'Tax amount for this category'
          },
          Category: {
            label: 'VAT Category',
            description: 'Category of VAT applied'
          },
          Percent: {
            label: 'VAT Rate (%)',
            description: 'Percentage rate of VAT applied'
          },
          Scheme: {
            label: 'Tax Scheme',
            description: 'Type of tax scheme'
          }
        },
        Total: {
          NetAmount: {
            label: 'Net Amount',
            description: 'Sum of all line items before tax'
          },
          TaxExclusiveAmount: {
            label: 'Amount excl. VAT',
            description: 'Total amount without VAT'
          },
          TaxInclusiveAmount: {
            label: 'Amount incl. VAT',
            description: 'Total amount with VAT'
          },
          PayableAmount: {
            label: 'Payable Amount',
            description: 'Final amount due for payment'
          }
        },
        ProfileID: {
          label: 'Profile ID',
          description: 'Business process type identifier'
        },
        CustomizationID: {
          label: 'Customization ID',
          description: 'Technical specification version identifier'
        },
        Notes: {
          Note: {
            label: 'Note',
            description: 'Any general notes about the invoice'
          }
        },
        InvoiceLine: {
          ID: {
            label: 'Line Item ID',
            description: 'Unique identifier for this line item'
          },
          Name: {
            label: 'Item Name',
            description: 'Name of the item'
          },
          Description: {
            label: 'Item Description',
            description: 'Detailed description of the item'
          },
          Note: {
            label: 'Note',
            description: 'Any general notes about the invoice line'
          },
          Quantity: {
            label: 'Quantity',
            description: 'Number of items'
          },
          UnitPrice: {
            label: 'Unit Price',
            description: 'Price per unit'
          },
          NetAmount: {
            label: 'Net Amount',
            description: 'Sum of all line items before tax'
          },
          VATRate: {
            label: 'VAT Rate',
            description: 'Percentage rate of VAT applied'
          },
        }
      },
      'invoice.table.description': 'Description',
      'invoice.table.quantity': 'Quantity',
      'invoice.table.unitPrice': 'Unit Price',
      'invoice.table.netAmount': 'Net Amount',
      'invoice.buttons.addLine': 'Add Invoice Line',
      'invoice.buttons.deleteLine': 'Delete Line',

      'sections.invoiceInformation': 'Invoice Information',
      'sections.seller': 'Seller',
      'sections.buyer': 'Buyer',
      'sections.delivery': 'Delivery',
      'sections.payment': 'Payment',
      'sections.tax': 'Tax',
      'sections.total': 'Total',
      'sections.lineItems': 'Line Items',
      'sections.notes': 'Notes',
      'sections.other': 'Other',

      'xml.title': 'Generated XRechnung',
      'xml.copy': 'Copy',
      'xml.copied': 'Copied',
      'xml.download': 'Download XRechnung',
      'xml.preview': 'XRechnung Preview',

      'xrechnungViewer.title': 'Free XRechnung & XML Viewer',
      'xrechnungViewer.subtitle': 'View and validate your XRechnung and XML files instantly - No registration required',
      'xrechnungViewer.description': 'Upload your XRechnung or XML file with one click to view its contents in a beautiful, structured format. Free to use, no registration needed.',
      'xrechnungViewer.uploadButton': 'Upload XRechnung or XML File',

      // Multi-file processing message
      'converter.processing.multipleFiles': 'Processing files...',

      // File navigation in multi-file review
      'converter.fileNavigation.viewing': 'Viewing',
      'converter.fileNavigation.of': 'of',
      'converter.fileNavigation.previous': 'Previous',
      'converter.fileNavigation.next': 'Next',
      // Invoice Status Bubbles Tooltips
      'bubbles.statusPrefix': 'Status: ',
      'bubbles.currentSuffix': ' (Current)',
      'bubbles.status.not_started': 'Not Started',
      'bubbles.status.processing': 'Processing',
      'bubbles.status.processed_ready_for_download': 'Processed (Ready for Download)',
      'bubbles.status.downloaded': 'Downloaded',
      'bubbles.status.error': 'Error',
      invoiceTypes: {
        '325': '325 - Proforma Invoice',
        '326': '326 - Partial Invoice',
        '380': '380 - Invoice',
        '381': '381 - Credit Note',
        '383': '383 - Debit Note',
        '384': '384 - Corrected Invoice',
        '386': '386 - Prepayment Invoice',
        '387': '387 - Rental Invoice',
        '388': '388 - Tax Invoice',
        '389': '389 - Self-billed Invoice',
        '393': '393 - Factoring Invoice',
        '394': '394 - Lease Invoice',
        '575': '575 - Insurer Invoice',
        '623': '623 - Forwarder Invoice',
        '780': '780 - Freight Invoice',
        '875': '875 - Partial Invoice for Construction Services',
        '876': '876 - Final Partial Invoice for Construction Services',
        '877': '877 - Final Invoice for Construction Services',
        '935': '935 - Customs Invoice'
      }
    },
    de: {
      'converter.buttons.usesCredit': '(Verwendet 1 Credit)',
      'converter.buttons.startNew': 'Neu beginnen',
      'converter.pdfToXml.title': 'PDF zu XRechnung Konverter',
      'converter.pdfToXml.subtitle': 'Konvertieren Sie Ihre PDF-Rechnungen in Sekunden in strukturiertes XML/XRechnung-Format',
      'converter.converter': 'Konverter',
      'converter.xmlToPdf.subtitle': 'Konvertieren Sie Ihre XML/XRechnung-Dateien in Sekunden in PDF-Format',
      'converter.dropzone.title': 'Rechnung hier ablegen',
      'converter.dropzone.dragActive': 'Datei hier ablegen',
      'converter.dropzone.browse': 'oder zum Durchsuchen klicken',
      'converter.dropzone.supportedPdf': 'Unterstütztes Format: PDF (max 10MB)',
      'converter.dropzone.supportedXml': 'Unterstütztes Format: XML (max 10MB)',
      'converter.dropzone.noFile': 'Keine Datei ausgewählt',
      'converter.dropzone.clickToReplace': 'Klicken oder ziehen zum Ersetzen',
      'converter.steps.uploadPdf': 'PDF hochladen',
      'converter.steps.uploadXml': 'XML hochladen',
      'converter.steps.viewData': 'Daten prüfen',
      'converter.steps.downloadXml': 'XML herunterladen',
      'converter.steps.downloadPdf': 'PDF herunterladen',
      'converter.buttons.back': 'Zurück',
      'converter.buttons.next': 'Weiter',
      'converter.buttons.convertAnother': 'Weitere Datei konvertieren',
      'converter.errors.selectXml': 'Bitte wählen Sie eine XML-Datei aus.',
      'converter.errors.pdfGeneration': 'PDF-Generierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
      'converter.buttons.downloadPdf': 'PDF herunterladen',
      'converter.buttons.downloadXml': 'XRechnung herunterladen',
      'converter.currentCredits': 'Aktuelles Guthaben: {count}',
      'converter.downloadDisclaimer': 'Mit dem Download bestätigen Sie, dass Sie alle Daten auf Richtigkeit geprüft haben. Sie erkennen an, dass KI-Inhalte Fehler enthalten können, und übernehmen dafür die volle Verantwortung.',
      'converter.xmlContent': 'XML Inhalt',
      'converter.parsedData': 'Geparste Daten',

      'upload.steps': [
        'Hochladen & Extrahieren',
        'Prüfen & Bearbeiten',
        'XML herunterladen'
      ],
      'upload.dropzone.title': 'Rechnung hier ablegen',
      'upload.dropzone.dragActive': 'PDF hier ablegen',
      'upload.dropzone.browse': 'oder zum Durchsuchen klicken',
      'upload.dropzone.supportedFormatsPDF': 'Unterstütztes Format: PDF (max 10MB)',
      'upload.dropzone.supportedFormatsXML': 'Unterstütztes Format: XML (max 10MB)',
      'upload.dropzone.clickToReplace': 'Klicken oder ziehen zum Ersetzen',
      'upload.review.title': 'Rechnungsdaten prüfen & bearbeiten',
      'upload.review.checkCarefully': 'Alle Felder sind editierbar - bitte sorgfältig prüfen!',
      'upload.review.noData': 'Keine Daten verfügbar. Bitte laden Sie zuerst eine Rechnung hoch.',
      'upload.xml.title': 'Generierte XML',
      'upload.buttons.back': 'Zurück',
      'upload.buttons.next': 'Weiter',
      'upload.buttons.downloadXml': 'XML herunterladen',
      'upload.buttons.uploadPdf': 'PDF hochladen',
      'upload.buttons.checkData': 'Daten prüfen',
      'upload.loading.processing': 'Ihre Rechnung wird verarbeitet...',
      'upload.loading.extracting': 'Rechnungsdaten werden extrahiert...',
      'upload.loading.analyzing': 'Dokumentstruktur wird analysiert...',
      'upload.loading.mapping': 'Mapping zum XRechnung XML-Format...',
      'upload.loading.schema': 'XRechnung-Schema wird angewendet...',
      'upload.loading.validating': 'Ausgabe wird validiert...',
      'upload.errors.noFile': 'Bitte wählen Sie eine PDF-Datei aus.',
      'upload.errors.uploadFailed': 'Fehler beim Hochladen und Verarbeiten der Datei.',
      'upload.errors.xmlFailed': 'Fehler beim Generieren der XML.',
      'upload.errors.safariNetworkIssue': 'Safari-Netzwerkproblem erkannt. Versuchen Sie, diesen Tab aktiv zu halten, oder wechseln Sie zu Chrome/Firefox für bessere Performance.',
      'upload.errors.safariTimeout': 'Safari-Timeout erkannt. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut, oder verwenden Sie Chrome/Firefox.',
      'upload.validation.missingFields': 'Einige empfohlene Felder sind leer. Sie können trotzdem fortfahren, aber das Ausfüllen könnte für den behördlichen Austausch erforderlich sein.',
      'upload.validation.generateXml': 'XML generieren',

      // Processing status messages (German)
      'converter.processing.pending': 'Verarbeitung in Warteschlange...',
      'converter.processing.analyzing': 'Rechnung wird analysiert...',
      'converter.processing.completed': 'Verarbeitung abgeschlossen!',
      'converter.processing.failed': 'Verarbeitung fehlgeschlagen',
      'converter.processing.unknown': 'Verarbeitung läuft...',

      // New invoice fields translations (German)
      invoiceFields: {
        ID: {
          label: 'Rechnungsnummer',
          description: 'Eindeutige Kennung für diese Rechnung'
        },
        IssueDate: {
          label: 'Ausstellungsdatum',
          description: 'Datum, an dem die Rechnung ausgestellt wurde'
        },
        DueDate: {
          label: 'Fälligkeitsdatum',
          description: 'Datum, bis zu dem die Zahlung erfolgen sollte'
        },
        InvoiceTypeCode: {
          label: 'Rechnungstyp',
          description: 'Code zur Angabe des Rechnungstyps (z.B. 380 für Handelsrechnung)',
          selectPlaceholder: '--- Rechnungstyp auswählen ---'
        },
        DocumentCurrencyCode: {
          label: 'Währung',
          description: 'Verwendete Hauptwährung (z.B. "EUR")'
        },
        OrderReference: {
          label: 'Bestellreferenz',
          description: 'Einkaufsbestellnummer des Käufers'
        },
        ContractReference: {
          label: 'Vertragsreferenz',
          description: 'Vertragsnummer'
        },
        BuyerReference: {
          label: 'Käuferreferenz (Leitweg-ID)',
          description: 'Interne Referenznummer (Leitweg‑ID) des Käufers'
        },
        Seller: {
          LegalName: {
            label: 'Juristischer Name',
            description: 'Offiziell eingetragener Name des Verkäufers'
          },
          CompanyID: {
            label: 'Umsatzsteuer-Identifikationsnummer',
            description: 'Umsatzsteuer-Registrierungsnummer des Verkäufers'
          },
          CompanyLegalForm: {
            label: 'Rechtsform des Unternehmens',
            description: 'Rechtsform des verkaufenden Unternehmens'
          },
          Street: {
            label: 'Straße',
            description: 'Straßenadresse des Verkäufers'
          },
          City: {
            label: 'Stadt',
            description: 'Stadt des Verkäufers'
          },
          PostalCode: {
            label: 'Postleitzahl',
            description: 'Postleitzahl des Verkäufers'
          },
          CountryCode: {
            label: 'Ländercode',
            description: 'Zweibuchstabiger Ländercode des Verkäufers'
          },
          EndpointID: {
            label: 'Elektronische Adresse',
            description: 'Identifiziert die elektronische Adresse des Verkäufers, an die die Applikationsantwort auf die Rechnung gesendet werden kann.'
          },
          Email: {
            label: 'E-Mail',
            description: 'Kontakt-E-Mail-Adresse des Verkäufers'
          },
          ContactName: {
            label: 'Name des Ansprechpartners',
            description: 'Name der Kontaktperson beim Verkäufer'
          },
          Phone: {
            label: 'Telefon',
            description: 'Telefonnummer des Verkäufers'
          }
        },
        Buyer: {
          LegalName: {
            label: 'Juristischer Name',
            description: 'Offiziell eingetragener Name des Käufers'
          },
          Street: {
            label: 'Straße',
            description: 'Straßenadresse des Käufers'
          },
          City: {
            label: 'Stadt',
            description: 'Stadt des Käufers'
          },
          PostalCode: {
            label: 'Postleitzahl',
            description: 'Postleitzahl des Käufers'
          },
          CountryCode: {
            label: 'Ländercode',
            description: 'Zweibuchstabiger Ländercode des Käufers'
          },
          EndpointID: {
            label: 'Elektronische Adresse',
            description: 'Identifiziert die elektronische Adresse des Käufers, an die die Applikationsantwort auf die Rechnung gesendet werden kann.'
          }
        },
        Payment: {
          IBAN: {
            label: 'IBAN',
            description: 'Internationale Bankkontonummer für Zahlungen (z.B. IBAN)'
          },
          BIC: {
            label: 'BIC',
            description: 'Bank-Identifikationscode'
          },
          Type: {
            label: 'Art',
            description: 'Art der Zahlung'
          },
          Terms: {
            label: 'Zahlungsbedingungen',
            description: 'Beschreibung der Zahlungsbedingungen (z.B. "Netto innerhalb von 30 Tagen")'
          }
        },
        Tax: {
          Amount: {
            label: 'Steuerbetrag',
            description: 'Gesamte Umsatzsteuer'
          },
          BaseAmount: {
            label: 'Bemessungsgrundlage',
            description: 'Betrag, auf den die Umsatzsteuer berechnet wird'
          },
          TaxSubamount: {
            label: 'Steuerteilbetrag',
            description: 'Steuerbetrag für diese Kategorie'
          },
          Category: {
            label: 'USt-Kategorie',
            description: 'Angewandte Umsatzsteuer-Kategorie'
          },
          Percent: {
            label: 'USt-Satz (%)',
            description: 'Prozentualer Umsatzsteuersatz'
          },
          Scheme: {
            label: 'Steuersystem',
            description: 'Art des Steuersystems'
          }
        },
        Total: {
          NetAmount: {
            label: 'Nettobetrag',
            description: 'Summe aller Posten vor Steuern'
          },
          TaxExclusiveAmount: {
            label: 'Betrag exkl. USt',
            description: 'Gesamtbetrag ohne Umsatzsteuer'
          },
          TaxInclusiveAmount: {
            label: 'Betrag inkl. USt',
            description: 'Gesamtbetrag mit Umsatzsteuer'
          },
          PayableAmount: {
            label: 'Zahlbarer Betrag',
            description: 'Endbetrag zur Zahlung'
          }
        },
        ProfileID: {
          label: 'Profil-ID',
          description: 'Geschäftsprozess-Typkennzeichen'
        },
        CustomizationID: {
          label: 'Anpassungs-ID',
          description: 'Kennzeichnung der technischen Spezifikationsversion'
        },
        Notes: {
          Note: {
            label: 'Notiz',
            description: 'Beliebige allgemeine Anmerkungen zur Rechnung'
          }
        },
        InvoiceLine: {
          ID: {
            label: 'Positionsnummer',
            description: 'Eindeutige Kennung für diese Position'
          },
          Name: {
            label: 'Artikelname',
            description: 'Name des Artikels'
          },
          Description: {
            label: 'Artikelbeschreibung',
            description: 'Detaillierte Beschreibung des Artikels'
          },
          Note: {
            label: 'Notiz',
            description: 'Beliebige allgemeine Anmerkungen zur Rechnung'
          },
          Quantity: {
            label: 'Menge',
            description: 'Anzahl der Artikel'
          },
          UnitPrice: {
            label: 'Einzelpreis',
            description: 'Preis pro Einheit'
          },
          NetAmount: {
            label: 'Nettobetrag',
            description: 'Summe aller Posten vor Steuern'
          },
          VATRate: {
            label: 'Umsatzsteuersatz',
            description: 'Prozentualer Umsatzsteuersatz'
          },
        }
      },
      'invoice.table.description': 'Beschreibung',
      'invoice.table.quantity': 'Menge',
      'invoice.table.unitPrice': 'Einzelpreis',
      'invoice.table.netAmount': 'Nettobetrag',
      'invoice.buttons.addLine': 'Rechnungsposition hinzufügen',
      'invoice.buttons.deleteLine': 'Position löschen',

      'sections.invoiceInformation': 'Rechnungsinformationen',
      'sections.seller': 'Verkäufer',
      'sections.buyer': 'Käufer',
      'sections.delivery': 'Lieferung',
      'sections.payment': 'Zahlung',
      'sections.tax': 'Steuern',
      'sections.total': 'Gesamt',
      'sections.lineItems': 'Rechnungspositionen',
      'sections.notes': 'Anmerkungen',
      'sections.other': 'Andere',

      'xml.title': 'Generierte XRechnung',
      'xml.copy': 'Kopieren',
      'xml.copied': 'Kopiert',
      'xml.download': 'XRechnung herunterladen',
      'xml.preview': 'XRechnung-Vorschau',

      'xrechnungViewer.title': 'Kostenloser XRechnung & XML Viewer',
      'xrechnungViewer.subtitle': 'Betrachten und validieren Sie Ihre XRechnung und XML-Dateien sofort - Keine Registrierung erforderlich',
      'xrechnungViewer.description': 'Laden Sie Ihre XRechnung oder XML-Datei mit einem Klick hoch, um den Inhalt in einem übersichtlichen, strukturierten Format anzuzeigen. Kostenlos nutzbar, keine Registrierung erforderlich.',
      'xrechnungViewer.uploadButton': 'XRechnung oder XML-Datei hochladen',

      // Mehrfachverarbeitung
      'converter.processing.multipleFiles': '{count} Dateien werden verarbeitet...',

      // Dateinavigation in der Mehrfachprüfung
      'converter.fileNavigation.viewing': 'Anzeigen',
      'converter.fileNavigation.of': 'von',
      'converter.fileNavigation.previous': 'Zurück',
      'converter.fileNavigation.next': 'Weiter',
      // Invoice Status Bubbles Tooltips
      'bubbles.statusPrefix': 'Status: ', // Or 'Zustand: '
      'bubbles.currentSuffix': ' (Aktuell)',
      'bubbles.status.not_started': 'Nicht begonnen',
      'bubbles.status.processing': 'In Bearbeitung',
      'bubbles.status.processed_ready_for_download': 'Verarbeitet (Bereit zum Download)',
      'bubbles.status.downloaded': 'Heruntergeladen',
      'bubbles.status.error': 'Fehler',
      invoiceTypes: {
        '325': '325 - Proformarechnung',
        '326': '326 - Teilrechnung',
        '380': '380 - Rechnung',
        '381': '381 - Gutschriftanzeige',
        '383': '383 - Belastungsanzeige',
        '384': '384 - Rechnungskorrektur',
        '386': '386 - Vorauszahlungsrechnung',
        '387': '387 - Mietrechnung',
        '388': '388 - Steuerrechnung',
        '389': '389 - Selbstfakturierte Rechnung',
        '393': '393 - Inkasso-Rechnung',
        '394': '394 - Leasing-Rechnung',
        '575': '575 - Rechnung des Versicherers',
        '623': '623 - Speditionsrechnung',
        '780': '780 - Frachtrechnung',
        '875': '875 - Teilrechnung für Bauleistungen',
        '876': '876 - Teilschlussrechnung für Bauleistungen',
        '877': '877 - Schlussrechnung für Bauleistungen',
        '935': '935 - Zollrechnung'
      }
    }
  };